import { Injectable } from '@angular/core';

import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PrimaryStateService extends DataService<string> {
  constructor() {
    super();
    this.set('nsw');
  }

  public override async set(val: string | undefined) {
    super.set(typeof val === 'string' ? val.toLowerCase() : val);
  }
}
